import { useState } from 'react';

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-[#0F0F1A]/95 backdrop-blur-md border-b border-white/5">
      <nav className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="text-2xl md:text-3xl font-black tracking-tighter">
              <span className="text-amber-400">69</span>
              <span className="text-white">视频</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/') ? 'bg-amber-400/15 text-amber-400' : 'text-gray-300 hover:text-white hover:bg-white/5'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/sigua-video"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname.startsWith('/category') ? 'bg-amber-400/15 text-amber-400' : 'text-gray-300 hover:text-white hover:bg-white/5'
              }`}
            >
              视频分类
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/about') ? 'bg-amber-400/15 text-amber-400' : 'text-gray-300 hover:text-white hover:bg-white/5'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 text-gray-400 hover:text-white hover:bg-white/10 transition-colors cursor-pointer">
              <i className="ri-search-line text-lg"></i>
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 text-gray-300 hover:text-white transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden border-t border-white/5 bg-[#0F0F1A] px-4 py-4">
          <div className="flex flex-col gap-1">
            <Link to="/" onClick={() => setMobileOpen(false)} className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap ${isActive('/') ? 'bg-amber-400/15 text-amber-400' : 'text-gray-300 hover:text-white hover:bg-white/5'}`}>首页</Link>
            <Link to="/category/sigua-video" onClick={() => setMobileOpen(false)} className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap ${location.pathname.startsWith('/category') ? 'bg-amber-400/15 text-amber-400' : 'text-gray-300 hover:text-white hover:bg-white/5'}`}>视频分类</Link>
            <Link to="/about" onClick={() => setMobileOpen(false)} className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap ${isActive('/about') ? 'bg-amber-400/15 text-amber-400' : 'text-gray-300 hover:text-white hover:bg-white/5'}`}>关于我们</Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;